import { render, staticRenderFns } from "./runSheetCourtTab.vue?vue&type=template&id=80f5f0da&scoped=true"
import script from "./runSheetCourtTab.vue?vue&type=script&lang=js"
export * from "./runSheetCourtTab.vue?vue&type=script&lang=js"
import style0 from "./runSheetCourtTab.vue?vue&type=style&index=0&id=80f5f0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f5f0da",
  null
  
)

export default component.exports